import {config} from "./config";
import {request} from "./request";


function getItems(data, cb, fail_cb) {
    var that = this;
    request.get.call(this, config.apiList.wechatGroups, data, function (res) {
        that.groupTotal = res.result.total;
        that.groups = res.result.groups
        if (cb) {
            cb(res)
        }

    }, fail_cb)
}


var wechatGroupsApi = {
    getItems: getItems
}

export {wechatGroupsApi}